var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-items-categories" },
    [
      _c("span", { staticClass: "search-items-categories__name" }, [
        _vm._v("Найти в категории"),
      ]),
      _vm._v(" "),
      _vm._l(_vm.items, function (item) {
        return _c("search-item-category", {
          key: "item-category-" + item.id,
          staticClass: "search-items-categories__item",
          attrs: { link: item.link, name: item.name },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }